export interface IAuthCred {
  username: string;
  password: string;
}
export interface IAuthResp {
  token: string;
  refreshToken: string;
  lifetime: number;
  brokerUrl: string;
}

export enum userStatus {
  LOCKED = "LOCKED",
  ACTIVE = "ACTIVE",
}

export enum profileNames { // the order is important here because it is used to assign profile ranks which are used to hide/show items in profile selector
  ONSITE_OPERATOR = "onsite_operator", // profile rank 0
  VIEWER = "viewer", // profile rank 1
  EDITOR = "editor", // profile rank 2
  ACCOUNT_ADMIN = "account_admin", // profile rank 3
  SUPER_USER = "super_user", // profile rank 4
  SYSTEM_DEV = "system_dev", // profile rank 5
}

export enum badgeDriveLicence {
  LITE = "LITE",
  PRO = "PRO",
  NONE = "NONE",
}

export interface userProfile {
  id: string;
  name: profileNames;
  userRoles: any[];
}

export interface userAccount {
  id: string;
  name: string;
  image?: string;
  numEvents?: number;
  numUsers?: number;
}

export default interface IUser {
  id: number;
  username: string;
  fullName: string;
  email: string;
  password: string;
  image: string;
  status: userStatus;
  profile: userProfile;
  account: userAccount;
  badgedrive_license: badgeDriveLicence;
}
